import BaDriverIcon from '../../../components/Icons/BaDriverIcon';
import BulbIcon from '../../../components/Icons/BulbIcon';
import ComplianceIcon from '../../../components/Icons/ComplianceIcon';
import DashboardIcon from '../../../components/Icons/DashboardIcon';
import DemoRequestIcon from '../../../components/Icons/DemoRequestIcon';
import PerformanceMonitoringIcon from '../../../components/Icons/PerformanceMonitoringIcon';
import RevenueIcon from '../../../components/Icons/RevenueIcon';
import UserManagementIcon from '../../../components/Icons/UserManagementIcon';
import WaitlistSubmissionsIcon from '../../../components/Icons/WaitlistSubmissionsIcon';
import { UserRoleTypes } from '../../../enums/enums';
import {
  BA_DRIVER_VERIFICATION,
  BA_DRIVER_VERIFICATION_SUPER_ADMIN,
  COMPANY_INSIGHTS,
  DASHBOARD,
  DEMO_REQUESTS,
  KYC_COMPLIANCE,
  PERFORMANCE_MONITORING,
  REVENUE,
  USER_MANAGEMENT,
  WAITLIST_SUBMISSIONS,
} from '../../../routes/routeConstants';

interface INavConfig {
  title: string;
  path: string;
  icon: React.ReactNode;
}

export const SuperAdmin: INavConfig[] = [
  {
    title: 'Dashboard',
    path: DASHBOARD,
    icon: <DashboardIcon />,
  },
  {
    title: 'KYC Compliance',
    path: KYC_COMPLIANCE,
    icon: <ComplianceIcon />,
  },
  {
    title: 'User Management',
    path: USER_MANAGEMENT,
    icon: <UserManagementIcon />,
  },
  {
    title: 'Performance Monitoring',
    path: PERFORMANCE_MONITORING,
    icon: <PerformanceMonitoringIcon />,
  },
  {
    title: 'Revenue',
    path: REVENUE,
    icon: <RevenueIcon />,
  },

  {
    title: 'Company Insights',
    path: COMPANY_INSIGHTS,
    icon: <BulbIcon />,
  },

  {
    title: 'Demo Requests',
    path: DEMO_REQUESTS,
    icon: <DemoRequestIcon />,
  },

  {
    title: 'Driver Verification',
    path: BA_DRIVER_VERIFICATION_SUPER_ADMIN,
    icon: <BaDriverIcon />,
  },
];

export const Admin: INavConfig[] = [
  {
    title: 'Waitlist Submissions',
    path: WAITLIST_SUBMISSIONS,
    icon: <WaitlistSubmissionsIcon />,
  },

  {
    title: 'Demo Requests',
    path: DEMO_REQUESTS,
    icon: <DemoRequestIcon />,
  },

  {
    title: 'Driver Verification',
    path: BA_DRIVER_VERIFICATION,
    icon: <BaDriverIcon />,
  },
];

export const navConfig: Record<string, INavConfig[]> = {
  Admin,
  [UserRoleTypes.WAITLIST_ADMIN]: Admin,
  [UserRoleTypes.SUPER_ADMIN]: SuperAdmin,
};
